function stripP(html) {
  return html.replace(/<\/?p[^>]*>/g, ``);
}
export default stripP;
